import { Person } from '../../models/Entities/Person/Person';
import { PersonTypeEnum } from '../../models/Entities/Person/PersonCommands';
import { JuridictionIdentifierTypeEnum } from '../../models/Entities/Person/IdentifierType/IdentifierTypeModels';

// Shared helpers for every component of the persons (staff) module.

// Display name of a person, no matter if it is a natural or a juridical person
export const GetPersonDisplayName = (person: Person | undefined | null): string => {
  if (!person) return '';

  const fullName = [person.firstName, person.lastName].filter((part) => !!part).join(' ').trim();

  return person.businessName || fullName || `#${person.id}`;
};

export const IsNaturalPerson = (personType: number | undefined): boolean =>
  personType === PersonTypeEnum.NaturalPerson;

// Dates arrive from the API as ISO strings, forms work with yyyy-MM-dd
export const ToInputDate = (value: Date | string | undefined | null): string => {
  if (!value) return '';

  const date = value instanceof Date ? value : new Date(value);
  if (isNaN(date.getTime())) return '';

  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');

  return `${date.getFullYear()}-${month}-${day}`;
};

export const FromInputDate = (value: string | undefined): string | null => {
  if (!value) return null;

  const date = new Date(`${value}T00:00:00`);
  if (isNaN(date.getTime())) return null;

  return date.toISOString();
};

export const FormatDate = (value: Date | string | undefined | null): string => {
  if (!value) return '-';

  const date = value instanceof Date ? value : new Date(value);
  if (isNaN(date.getTime())) return '-';

  return date.toLocaleDateString();
};

export const PersonTypeOptions = [
  { key: PersonTypeEnum.NaturalPerson, textKey: 'persons.personType.natural', defaultText: 'Persona física' },
  { key: PersonTypeEnum.JuridicalPerson, textKey: 'persons.personType.juridical', defaultText: 'Persona jurídica' }
];

export const JuridictionTypeOptions = [
  { key: JuridictionIdentifierTypeEnum.National, textKey: 'persons.juridictionType.national', defaultText: 'Nacional' },
  { key: JuridictionIdentifierTypeEnum.Provincial, textKey: 'persons.juridictionType.provincial', defaultText: 'Provincial' },
  { key: JuridictionIdentifierTypeEnum.Municipal, textKey: 'persons.juridictionType.municipal', defaultText: 'Municipal' },
  { key: JuridictionIdentifierTypeEnum.International, textKey: 'persons.juridictionType.international', defaultText: 'Internacional' },
  { key: JuridictionIdentifierTypeEnum.Internal, textKey: 'persons.juridictionType.internal', defaultText: 'Interno' }
];
